module.exports = __webpack_public_path__ + "img/p-single-10.81d8feba.jpg";